const ES_PLURAL_SUFFIX_REGEX = /(?:s|x|z|ch|sh)$/i;

export function pluralize(
	count: number,
	singular: string,
	plural = ES_PLURAL_SUFFIX_REGEX.test(singular)
		? `${singular}es`
		: `${singular}s`,
) {
	return count === 1 ? singular : plural;
}
